import { render, staticRenderFns } from "./BalanceReport.vue?vue&type=template&id=22ad3ad7"
import script from "./BalanceReport.vue?vue&type=script&lang=js"
export * from "./BalanceReport.vue?vue&type=script&lang=js"
import style0 from "./BalanceReport.vue?vue&type=style&index=0&id=22ad3ad7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports